import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0',

    '& h1': {
      margin: 0,
      padding: 0,
      fontFamily: 'Nunito',
      fontSize: '0.875rem',
      fontWeight: 700,
      lineHeight: '1.25rem',
      color: '#0f0f1e',
    },

    '& span': {
      margin: 0,
      padding: 0,
      fontFamily: 'Nunito',
      fontSize: '0.625rem',
      fontWeight: 600,
      lineHeight: '0.875rem',
      color: getRGBA('#0F0F1E', 0.6),
    },
  },

  divisor: {
    width: '0.12rem',
    height: '1.5rem',
    backgroundColor: '#0F0F1E',
  },
})

export { useStyles }
